import { BaseModel } from './BaseModel';

export class Modulo extends BaseModel {
  categoriaModuloId?: number;
  codiceErp?: number;
  sottoModuli?: Modulo[];
}
